<template>
  <div>
    <div class="container-md plr-0">
      <div class="container-bg p-4 pright-g">
        <div
          class="d-flex itmg-tit-wrap"
          style="justify-content: space-between"
        >
          <h3 class="list-h3">Beheer informatietypen</h3>
          <div>
            <router-link
              :to="{ name: 'create-itemtype' }"
              class="btn btn-dark btn-sm mr-3 list-btn"
            >
              <i class="fa fa-plus"></i> Informatietype
            </router-link>
          </div>
        </div>
        <div class="row mt-5">
          <div
            class="col-sm-12 col-md-10 ml-auto d-flex itmg-src-wrap"
            style="justify-content: space-between"
          >
            <div class="form-group w-100 mr-2">
              <select
                style="color: white"
                name=""
                id=""
                class="form-control bg-dark"
              >
                <option value="">Naam</option>
              </select>
            </div>
            <div class="form-group w-100">
              <input type="text" class="form-control" placeholder="Zoeken" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <a
              v-for="(group, index) in list"
              :key="'itemgroup' + index"
              data-toggle="collapse"
              :href="'#collapse_' + group.id"
              class="
                flex-container
                collapsed
                w-100
                flex-body
                mt-3
                d-flex
                group-item
              "
              style="justify-content: space-between"
            >
              <div class="item text-center d-flex w-100 pl-2">
                <i class="fas fa-bars text-white mt-1"></i>
                <div class="item group-name text-white">{{ group.title }}</div>
              </div>
              <div class="item text-white text-right pr-3">
                <!-- <a href="javascript:void(0)" class="action-btn text-white"
                  ><i class="fa fa-eye"></i
                ></a> -->
                <a
                  href="javascript:void(0)"
                  @click="deleteGroup(group.id)"
                  class="action-btn text-white mr-3"
                  ><i class="fa fa-trash"></i
                ></a>
                <router-link
                  :to="{ name: 'edit-itemtype', params: { id: group.id } }"
                  class="action-btn text-white"
                  ><i class="fas fa-pencil-alt"></i
                ></router-link>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import itemtype from "./itemtype";
export default {
  components: {
    // eslint-disable-next-line
    itemtype: itemtype,
  },
  data() {
    return {
      list: [],
      info_groups: [],
      info_group: {
        title: "",
        description: "",
        public: false,
        committees: [],
        members: [],
        fields: [],
      },
      selectedInfoGroupMembers: [],
      imagesrc: null,
      field: { label: "", field: "" },
      saving: false,
      create_itemtype: { active: false, public: false, parent_id: 0 },
      clicked_id: null,
      clickedGroup: null,
      clickedGroupIndex: null,
    };
  },
  computed: {
    ...mapState({
      selectedCommittees: (state) => state.selectedCommittees,
      selectedMembers: (state) => state.selectedMembers,
      selectedItemGroups: (state) => state.selectedItemGroups,
      itemgroup_parent_id: (state) => state.itemgroup_parent_id,
    }),
  },
  methods: {
    // eslint-disable-next-line
    editGroup(group) {
      group.itemgroups.forEach((ig) => {
        this.$store.commit("addSelectedItemgroup", ig);
      });

      this.info_groups = group.structure;

      this.clicked_id = group.id;
      this.create_itemtype = {
        name: group.title,
        description: group.description,
      };
      var selectedMembers = group.members.map((item) => {
        return { id: item.id, text: item.display_name };
      });

      var selectedItemgroups = group.itemgroups.map((item) => {
        return { id: item.id, text: item.title };
      });
      this.$store.state.selectedMembers = selectedMembers;
      this.$store.state.selectedItemGroups = selectedItemgroups;
      // HERE

      window.$("#itemGroup").modal("show");
    },
    openInfoModal(group = null, index = null) {
      if (group != null) {
        this.info_group = { ...group };
        this.clickedGroup = group;
        this.clickedGroupIndex = index;
      } else {
        (this.info_group = {
          title: "",
          description: "",
          public: false,
          committees: [],
          members: [],
          fields: [],
        }),
          (this.clickedGroup = null);
        this.clickedGroupIndex = null;
        this.$store.state.selectedInfoGroupMembers = [];
        this.$store.state.selectedCommittees = [];
      }
      window.$("#structureModal").modal("show");
    },
    readImage() {
      var file = document.getElementById("itemtypefile").files[0];
      var fileReader = new FileReader();
      var context = this;
      fileReader.onload = function(data) {
        context.imagesrc = data.currentTarget.result;
      };
      fileReader.readAsDataURL(file);
    },
    removeInfoGroup(id) {
      if (!window.confirm("Are you sure you want to delete this item?")) {
        return false;
      }
      this.info_groups = this.info_groups.filter((d) => d.id != id);
    },
    createInfoGroup() {
      var committees = this.selectedCommittees.map((d) => d.id);
      var members = this.$store.state.selectedInfoGroupMembers.map((d) => d.id);
      if (
        this.info_group.title.length == 0 ||
        this.info_group.description.length == 0
      ) {
        return false;
      }
      this.info_group.committees = committees;
      this.info_group.members = members;
      if (this.clickedGroupIndex === null) {
        this.info_group.id = Math.round(Math.random() * 999);
        this.info_groups.unshift({ ...this.info_group });
      } else {
        this.info_groups[this.clickedGroupIndex] = this.info_group;
      }

      this.$store.state.selectedInfoGroupMembers = [];
      this.$store.state.selectedCommittees = [];
      this.info_group = {
        title: "",
        description: "",
        public: false,
        committees: [],
        members: [],
        fields: [],
      };
      window.$("#structureModal").modal("hide");
    },
    addField() {
      if (this.field.label.length == 0 || this.field.field.length == 0) {
        return false;
      }
      this.field.id = Math.round(Math.random() * 999);
      this.info_group.fields.unshift({ ...this.field });
      this.field.label = "";
      this.field.field = "";
    },
    removeField(id) {
      this.info_group.fields = this.info_group.fields.filter((d) => d.id != id);
    },
    setParentId(id) {
      this.$store.state.selectedItemGroups = [];
      this.$store.state.selectedMembers = [];
      this.create_itemtype = {
        name: null,
        description: null,
        public: false,
        active: false,
      };
      this.$store.state.itemgroup_parent_id = id;
    },
    createItemgroup() {
      if (this.saving) return false;

      var selected_members = this.selectedMembers.map((d) => d.id);
      var selected_itemgroups = this.selectedItemGroups.map((d) => d.id);
      var itemtype = {
        title: this.create_itemtype.name,
        body: this.create_itemtype.description,
        active: this.create_itemtype.active,
        public: this.create_itemtype.public,
      };
      itemtype.selected_members = JSON.stringify(selected_members);
      itemtype.selected_itemgroups = JSON.stringify(selected_itemgroups);
      itemtype.structure = this.info_groups;

      if (this.imagesrc != null) {
        itemtype.image = this.imagesrc;
      }
      this.saving = true;
      this.$store
        .dispatch(this.clicked_id ? "put" : "post", {
          endpoint: this.clicked_id
            ? "api/v1/itemtypes/" + this.clicked_id
            : "api/v1/itemtypes",
          details: itemtype,
        })
        .then((data) => {
          window.location.reload();
          console.log(data);
        })
        .catch((error) => {
          this.saving = false;
          console.log(error.request);
        });
    },

    deleteGroup(id) {
      if (!window.confirm("Are you sure you want to delete this item?")) {
        return false;
      }
      this.$store
        .dispatch("delete", "api/v1/itemtypes/" + id)
        .then((d) => {
          console.log(d);
          window.location.reload();
        })
        .catch((e) => console.log(e));
    },
  },
  created() {
    this.$store.dispatch("get", "api/v1/itemtypes").then((data) => {
      console.log(data);
      this.list = data.data.data;
    });
  },
};
</script>
<style scoped>
.infoGroup {
  background: #4192D9;
  justify-content: space-between;
  color: white;
  display: flex;
  padding: 10px 15px;
  border-radius: 10px;
}
.field {
  background: #4192D9;
  border-radius: 10px;
  color: white;
  margin-top: 5px !important;
}
.circle img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 1px solid lightgray;
}

.field {
  background: #4192D9;
  border-radius: 10px;
  color: white;
  margin-top: 5px !important;
}
.circle img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 1px solid lightgray;
}
.card-body {
  background: transparent;
  border: none;
  padding: 0px 0px 0px 30px;
}
.card-body .group-item {
  margin-top: 5px !important;
}
.group-item .fa-chevron-right {
  transform: rotate(90deg);
}
.group-item.collapsed .fa-chevron-right {
  transform: rotate(0deg);
}
.group-item {
  text-decoration: none;
}
.action-btn {
  font-size: 13px;
  margin-right: 5px;
}
.group-name {
  font-size: 12px;
  text-align: left;
  margin-left: 10px !important;
}
.search-box {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #292929;
  border-radius: 4px;
  height: 40px;
  width: 20rem;
}

.search-btn {
  background: transparent;
  border: unset;
  margin-left: -30px;

  -webkit-appearance: none;
}

.btn {
  background: #292929 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 18px !important;
}

.custom-row {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
  opacity: 1;
}

.flex-container {
  display: flex;
  flex-flow: row wrap;
  position: relative;
  width: auto;
  align-items: center;

  opacity: 1;
}

.flex-body {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 1px 5px #0000004b;
  border-radius: 20px;
}

.item {
  flex: 1 1 18%;
  height: auto;
  margin: 4px;
  padding: 0px 0;
  width: auto;
}
</style>
